<template>
    <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="addUserInsert">新建</el-button>
                <el-button
                    type="warning"
                    plain
                    size="small"
                    icon="el-icon-edit"
                    :disabled="multipleSelection.length != 1"
                    @click="editUser(multipleSelection[0].id)"
                    >修改</el-button
                >
                <el-button
                    type="danger"
                    plain
                    size="small"
                    icon="el-icon-delete"
                    :disabled="multipleSelection.length <= 0"
                    @click="deleteUser(null)"
                    >删除</el-button
                >

                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="setLoginPassword()"
                >设置默认登录密码</el-button
                >

                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="setPatPassword()"
                >设置默认支付密码</el-button
                >

                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="openRemoveLimitDialog"
                >解除限制
                </el-button>
            </div>

            <div class="icon-group">
                <span title="搜索" class="icon-box" @click="search">
                    <Icon color="#606266">
                        <Search />
                    </Icon>
                </span>
                <span title="导出数据" class="icon-box" @click="exportPostList">
                    <Icon color="#606266">
                        <ArrowDownload24Regular />
                    </Icon>
                </span>
                <span class="icon-box" @click="refreshUserList">
                    <Icon color="#606266">
                        <Refresh />
                    </Icon>
                </span>
            </div>
        </div>
        <div class="flex-1 flex flex-col justify-between" style="min-height: 0; overflow: hidden;">
            <el-table
                v-loading="loading"
                height="100%"
                element-loading-background="rgba(245, 245, 245, 0.3)"
                size="small"
                :data="userList"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column align="center" type="selection" width="55"> </el-table-column>
                <el-table-column align="center" prop="name" label="头像" width="100">
                    <template slot-scope="scop">
                        <el-image
                            @click='updateSrcList(scop.row.userHeader)'
                            style="width: 30px; height: 30px"
                            :src="scop.row.userHeader"
                            :preview-src-list="srcList"
                        > </el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="userName" label="账号" width="150"> </el-table-column>
                <el-table-column align="center" prop="userMobile" label="手机" width="150"> </el-table-column>

                <el-table-column align="center" prop="userNickname" label="昵称" width="150"> </el-table-column>
                <el-table-column align="center" prop="gradeName" label="等级" width="150">
                    <template slot-scope="scop">
                        <div>{{ scop.row.mppGrade.gradeName }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="状态" width="100">
                    <template slot-scope="scop">
                        <el-tag type="success" effect="light" v-if="scop.row.status == 1">正常</el-tag>
                        <el-tag type="danger" effect="light" v-if="scop.row.status == 0">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="公司" width="180">
                    <template slot-scope="scop">
                        <el-tag size="normal" effect="light" v-if="scop.row.company">{{ scop.row.company.deptName }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="部门" width="180">
                    <template slot-scope="scop">
                        <el-tag size="normal" effect="light" v-if="scop.row.mppDept">{{ scop.row.mppDept.deptName }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="创建时间" width="150"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="260">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkUser(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editUser(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="editUserRouter(scop.row.id)">
                                <span class="operation-label">粉丝</span>
                            </div>
                            
                            <el-dropdown size="small">
                                <span class="el-dropdown-link">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                   <div v-if="isShow">
                                     <el-dropdown-item>
                                        <div class='theme-color' @click="ChangeRelationship(scop.row)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">变更推荐</span>
                                        </div>
                                     </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class='theme-color' @click="changeListFn(scop.row)">
                                            <Icon size="16">
                                                <Eye24Regular />
                                            </Icon>
                                            <span class="operation-label">变更记录</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class='theme-color' @click="audit(scop.row.id)">
                                            <Icon size="16">
                                                <Settings24Regular />
                                            </Icon>
                                            <span class="operation-label">审查路径</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class='theme-color' @click="auditRepair(scop.row.id)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">修复路径</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class='theme-color' @click="repairDirect(scop.row.id)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">修复直推</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class='theme-color' @click="repairTeam(scop.row.id)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">修复团队</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="showKDalog"> 
                                        <div class='theme-color' @click="changeKValue(scop.row)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">变更k值</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item> 
                                        <div class='theme-color' @click="releaseRecordFn(scop.row)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">凭证释放记录</span>
                                        </div>
                                    </el-dropdown-item>
                                    <!-- <el-dropdown-item>
                                        <div @click="deleteUser(scop.row.id)">
                                            <Icon size="16" style="color: red">
                                                <Delete24Regular />
                                            </Icon>
                                            <span class="operation-label" style="color: red;margin-left: 6px">删除</span>
                                        </div>
                                    </el-dropdown-item> -->
                                   </div>
                                   <div v-if="!isShow">
                                       <el-dropdown-item>
                                        <div class='theme-color' @click="restoreFans(scop.row)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">恢复粉丝</span>
                                        </div>
                                       </el-dropdown-item>
                                       <el-dropdown-item>
                                        <div class='theme-color' @click="unbindWechat(scop.row)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">解绑微信</span>
                                        </div>
                                        
                                       </el-dropdown-item>
                                   </div>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>

        <!-- 新增/查看/修改用户信息 -->
        <el-dialog :title="userStates[userState]" :visible.sync="showDialog" width="1000px" @close="closeDialog">
            <div>
                <el-form :model="user" ref="userForm" :rules="rules" label-width="80px" :inline="true" size="small">
                    <el-divider content-position="left">
                        <i class="el-icon-lock text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">账号信息</span>
                    </el-divider>
                    <el-form-item label="账号" prop="userName">
                        <el-input v-model="user.userName" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="登录密码"
                        prop="userPass"
                        :rules="user.id ? [] : [{ required: true, message: '密码不能为空', trigger: 'blur' }]"
					>
                        <el-input
                            type="password"
                            :placeholder="userState == 'add' ? '' : '若不修改，请留空'"
                            v-model="user.userPass"
                            size="small"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPass">
                        <el-input
                            type="password"
                            :placeholder="userState == 'add' ? '' : '若不修改，请留空'"
                            v-model="user.confirmPass"
                            size="small"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                            :rules="user.id ? [] : rules['confirmPass']"
                        ></el-input>
                    </el-form-item>
					<el-form-item
					    label="操作密码"
					    prop="operatePass"
					>
					    <el-input
					        type="password"
					        :placeholder="userState == 'add' ? '' : '若不修改，请留空'"
					        v-model="user.operatePass"
					        size="small"
					        :disabled="userState == 'check'"
					        style="width: 200px"
					    ></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="confirmOperate">
					    <el-input
					        type="password"
					        :placeholder="userState == 'add' ? '' : '若不修改，请留空'"
					        v-model="user.confirmOperate"
					        size="small"
					        :disabled="userState == 'check'"
					        style="width: 200px"
					    ></el-input>
					</el-form-item>
                    <el-form-item v-if="userState != 'edit'" label="推荐人" prop="parentId">
                        <GridSelect
                        style="width: 200px"
                        title="选择用户"
                        labelName="userName"
                        :disabled="userState == 'check'"
                        labelValue="id"
                        :value="user.parentId"
                        :limit="1"
                        size="small"
                        placeholder="请选择用户"
                        @getValue="getValuebrandId"
                        :columns="USER_code"
                        :searchs="USER_search"
                        dataListUrl="/mpp/user/findList"
                        entityBeanName="mppUser"
                        queryEntityUrl="/mpp/user/getFull"
                    >
                    </GridSelect>
                    </el-form-item>
                    <el-form-item label="超管">
                        <el-select
                            size="small"
                            v-model="user.isSa"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                        <el-option v-for='(item, index) in urgentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登录状态">
                        <el-select size="small" v-model="user.status" :disabled="userState == 'check'" style="width: 200px">
                            <el-option label="正常" :value="1"> </el-option>
                            <el-option label="禁用" :value="0"> </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="允许转账">
                        <el-select size="small" v-model="user.forbidTransfer" :disabled="userState == 'check'" style="width: 200px">
                            <el-option label="正常" :value="0"> </el-option>
                            <el-option label="禁用" :value="1"> </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-divider content-position="left">
                        <i class="el-icon-user text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">身份信息</span>
                    </el-divider>
                    <el-form-item label="昵称" prop="userNickname">
                        <el-input v-model="user.userNickname" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="手机" prop="userMobile">
                        <el-input v-model="user.userMobile" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input
                            v-model="user.userTelephone"
                            size="small"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="user.userEmail" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="实名">
                        <el-select
                            size="small"
                            v-model="user.authStatus"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-option label="未实名" :value="0"> </el-option>
                            <el-option label="已实名" :value="1"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="真实姓名">
                        <el-input v-model="user.userRealname" size="small" :disabled="userState == 'check'" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="头像">
                        <el-upload
                            action=""
                            style="width: 200px"
                            :disabled="userState == 'check'"
                            class="avatar-uploader"
                            :show-file-list="false"
                            :http-request="uploadAvatar"
                        >
                            <img v-if="user.userHeader" :src="user.userHeader" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            style="width: 200px"
                            type="textarea"
                            :rows="9"
                            v-model="user.remarks"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-divider content-position="left">
                        <i class="el-icon-postcard text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">组织架构</span>
                    </el-divider>
                    <el-form-item label="公司" prop="companyId">
                        <el-select
                            size="small"
                            v-model="user.companyId"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-tree default-expand-all :data="departmentList" :props="treeProps">
                                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                    <el-option :label="node.label" :value="data.id"> </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="部门" prop="deptId">
                        <el-select
                            size="small"
                            v-model="user.deptId"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-tree default-expand-all :data="departmentList" :props="treeProps">
                                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                    <el-option :label="node.label" :value="data.id"> </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工号" prop="workNumber">
                        <el-input style="width: 200px" v-model="user.workNumber" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="岗位">
                        <el-select
                            size="small"
                            v-model="user.postIdList"
                            multiple
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-option v-for="post in postList" :key="post.id" :label="post.postName" :value="post.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色">
                        <el-select
                            size="small"
                            v-model="user.roleIds"
                            multiple
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-option v-for="role in roleList" :key="role.id" :label="role.roleName" :value="role.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="个人业绩" prop="workNumber">
                        <el-input
                            style="width: 200px"
                            v-model="user.personalPerformance"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item> -->
                    <el-divider content-position="left">
                        <i class="el-icon-postcard text-lg"></i>
                        <span class="ml-1 text-base text-black font-semibold">权益相关</span>
                    </el-divider>
					
					<el-form-item label="等级">
					    <el-select
					        size="small"
					        v-model="user.gradeId"
					        placeholder="请选择"
					        :disabled="userState == 'check'"
					        style="width: 200px"
					    >
					        <el-option v-for="role in mppGradeList" :key="role.id" :label="role.gradeName" :value="role.id"> </el-option>
					    </el-select>
					</el-form-item>

                    <el-form-item label="手动授权" prop="isAuthGrade">
                        <el-select size="small" v-model="user.isAuthGrade" :disabled="userState == 'check'" style="width: 200px">
                            <el-option label="手动授权" :value="1"> </el-option>
							<el-option label="没有授权" :value="0"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="授权等级" prop="authGradeId">
                        <!-- <el-input style="width: 200px" v-model="user.handGrade" size="small" :disabled="userState == 'check'"></el-input> -->
                        <el-select
                            size="small"
                            v-model="user.authGradeId"
                            placeholder="请选择"
                            :disabled="userState == 'check'"
                            style="width: 200px"
                        >
                            <el-option v-for="role in mppGradeList" :key="role.id" :label="role.gradeName" :value="role.id"> </el-option>
                        </el-select>
                    </el-form-item>

					<el-form-item label="超级会员" prop="isMember">
					    <el-select size="small" v-model="user.isMember" :disabled="userState == 'check'" style="width: 200px">
					        <el-option label="是" :value="1"> </el-option>
							<el-option label="否" :value="0"> </el-option>
					    </el-select>
					</el-form-item>
					<el-form-item label="到期时间" prop="memberExpiration" v-if='user.isLimit == user.isLimit'>
					    <el-date-picker
					        :disabled="userState == 'check'"
					        style="width: 200px"
					        v-model="user.memberExpiration"
					        type="datetime"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        placeholder="选择会员到期时间">
					    </el-date-picker>
					</el-form-item>
                    
					<el-form-item label="换门头">
					    <el-select size="small" v-model="user.isChangeUser" :disabled="userState == 'check'" style="width: 200px">
					        <el-option label="是" :value="1"> </el-option>
					        <el-option label="否" :value="0"> </el-option>
					    </el-select>
					</el-form-item>
					
					
					<el-form-item label="权重" prop="weight">
					    <el-input style="width: 200px" v-model="user.weight" size="small" :disabled="userState == 'check'"></el-input>
					</el-form-item>
					<el-form-item label="限制收益">
                        <el-select size="small" v-model="user.isLimit" :disabled="userState == 'check'" style="width: 200px">
                            <el-option label="是" :value="1"> </el-option>
                            <el-option label="否" :value="0"> </el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item label="解除时间" prop="removeLimitTime" v-if='user.isLimit == user.isLimit'>
					    <el-date-picker
					        :disabled="userState == 'check'"
					        style="width: 200px"
					        v-model="user.removeLimitTime"
					        type="datetime"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        placeholder="选择日期时间">
					    </el-date-picker>
					</el-form-item>
                    <el-form-item label="限制原因" prop="limitReason" v-if='user.isLimit == user.isLimit'>
                        <el-input type="textarea" v-model="user.limitReason" style='width: 200px;height: 32px' :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="商家数量" prop="shopNum" >
                        <el-input-number type="textarea" v-model="user.shopNum" style='width: 200px;height: 32px' :disabled="userState == 'check'" :min="0"  ></el-input-number>
                    </el-form-item>

                    <!-- <el-form-item label="直推人数" prop="">
                        <el-input style="width: 200px" v-model="user.directNumber" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="团队人数" prop="">
                        <el-input style="width: 200px" v-model="user.teamNumber" size="small" :disabled="userState == 'check'"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="个人业绩" prop="">
                        <el-input
                            style="width: 200px"
                            v-model="user.personalPerformance"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="团队业绩" prop="">
                        <el-input
                            style="width: 200px"
                            v-model="user.teamPerformance"
                            size="small"
                            :disabled="userState == 'check'"
                        ></el-input>
                    </el-form-item> -->
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeDialog">关闭</el-button>
                <el-button type="primary" @click="submitForm()" v-if="userState != 'check'">确定</el-button>
            </div>
        </el-dialog>

        <!-- 变更关系 -->
        <el-dialog title="变更推荐关系" :visible.sync="changeVisible" width="30%" :before-close="handleClose">
            <el-form ref="form" size="mini" label-width="120px">
                <el-form-item label="选择推荐人">
                    <GridSelect
                        style="width: 200px"
                        title="选择用户"
                        labelName="userName"
                        labelValue="id"
                        :value="queryForm.userId"
                        :limit="1"
                        size="small"
                        placeholder="请选择用户"
                        @getValue="getValue"
                        :columns="USER_code"
                        :searchs="USER_search"
                        dataListUrl="/mpp/user/findList"
                        entityBeanName="mppUser"
                        queryEntityUrl="/mpp/user/getFull"
                    >
                    </GridSelect>
                </el-form-item>
                <el-form-item label="修改原因">
                    <div style="width: 200px;display: flex;align-items: center">
                        <el-input placeholder="请输入内容" type="textarea" v-model="updateReason"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="上传纸质申请单">
                    <div style="width: 200px;display: flex;align-items: center">
                        <el-upload
                            style="width: 200px;height: 200px;"
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="uploadPic"
                        >
                            <template v-if="uploadLoading">
                                <i class="el-icon-loading avatar-uploader-icon"></i>
                            </template>
                            <template v-else>
                                <img v-if="updateImg" :src="updateImg" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </template>
                        </el-upload>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="finish">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="粉丝列表" :visible.sync="dialogVisible" width="80%" >
            <userlistTablePopup v-if="dialogVisible" :userId="userTablePopupId"></userlistTablePopup>
        </el-dialog>

        <!-- 变更记录列表 -->
        <el-dialog title="变更记录列表" :visible.sync="changeListVisible" width="80%">
            <el-table :data="changeList">
                <el-table-column prop="oldNickName" label="原推荐人昵称" width="105"></el-table-column>
                <el-table-column prop="oldPhone" label="原推荐人手机号" width="120"></el-table-column>
                <el-table-column prop="inviteNickName" label="新推荐人昵称" width="105"></el-table-column>
                <el-table-column prop="invitePhone" label="新推荐人手机号" width="120"></el-table-column>
                <el-table-column prop="createNickName" label="操作人" width="85"></el-table-column>
                <el-table-column prop="createPhone" label="操作人手机号" width="115"></el-table-column>
                <el-table-column prop="inviteContent" label="变更内容" width="250"></el-table-column>
                <el-table-column prop="pictureUrl" label="申请单" width="120">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.pictureUrl"
                            style="width: 100px; height: 100px"
                            :src="scope.row.pictureUrl"
                            fit="fill"
                            lazy
                            :preview-src-list="imgList"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="changeReason" label="变更理由" width="250"></el-table-column>
                <el-table-column prop="ipAddress" label="操作ip"></el-table-column>
                <el-table-column prop="createTime" label="操作时间"></el-table-column>
            </el-table>
        </el-dialog>

        <!-- 解除限制弹框 -->
        <el-dialog title="解除限制" :visible.sync="removeLimitVisible" width="30%" :before-close="closeRemoveLimitDialog">
            <el-form ref="removeLimitForm" :model="removeLimitForm" label-width="100px" size="small">
                <el-form-item label="手机号" prop="phone">
                    <el-input
                        v-model="removeLimitForm.phone"
                        placeholder="请输入手机号"
                        style="width: 200px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="上传图片" prop="limitPicture">
                    <el-upload
                        style="width: 200px;height: 200px;"
                        class="avatar-uploader"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadLimitPicture"
                    >
                        <template v-if="limitUploadLoading">
                            <i class="el-icon-loading avatar-uploader-icon"></i>
                        </template>
                        <template v-else>
                            <img v-if="removeLimitForm.limitPicture" :src="removeLimitForm.limitPicture" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </template>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeRemoveLimitDialog">取 消</el-button>
                <el-button type="primary" @click="submitRemoveLimit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 变更k值弹框 -->
        <el-dialog title="变更k值" :visible.sync="changeKValueVisible" width="30%" :before-close="closeChangeKValueDialog">
            <el-form ref="changeKValueForm" :model="changeKValueForm" label-width="100px" size="small">
                <el-form-item label="是否参与计算" prop="isChange">
                    <el-select
                        v-model="changeKValueForm.isChange"
                        placeholder="请选择"
                        style="width: 200px"
                    >
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="变更k值" prop="kValue">
                    <el-input
                        v-model="changeKValueForm.kValue"
                        placeholder="请输入k值"
                        style="width: 200px"
                        @input="handleKValueInput"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeChangeKValueDialog">取 消</el-button>
                <el-button type="primary" @click="submitChangeKValue">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Edit24Regular, Delete24Regular, Eye24Regular, Stop16Regular, Settings24Regular } from '@v2icons/fluent';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowDown, Search } from '@v2icons/tabler';
import { getUserList, getUserDetail, addUserInsert, deleteUser, uploadAvatar,updateById } from '@/api/user.js';

import { exprotExcel, importTemplate, importDate, get, post, postJson, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect';
import eventBus from '../../api/eventBus';
import { USER, USER_SEARCH, PROMOTER, PROMOTER_SEARCH } from '@/utils/constant.js'
import userlistTablePopup from './common/userlistTablePopup.vue';
export default {
    name: 'UserListTable',
    components: {
        GridDots,
        Refresh,
        Printer,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        Settings24Regular,
        userlistTablePopup
    },
    props: {
        checkState: String,
        queryForm: Object,
        departmentList: Array,
        postList: Array,
        roleList: Array,
        mppGradeList: Array,
        isShow: {
            type: Boolean,
            default: true
        },
        showKDalog: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetUserList();
                this.getUserList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetUserList();
                this.getUserList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        var passwordValidator = (rule, value, callback) => {
            if (this.userState == 'add') {
                if (this.user.userPass === null) {
                    callback(new Error('登录密码不能为空!'));
                } else if (this.user.confirmPass === null) {
                    callback(new Error('确认密码不能为空!'));
                } else if (this.user.userPass !== this.user.confirmPass) {
                    callback(new Error('两次密码输入不一致!'));
                } else {
                    callback();
                }
            } else if (this.userState == 'edit') {
                if (this.user.userPass !== null) {
                    if (this.user.confirmPass === null) {
                        callback(new Error('确认密码不能为空!'));
                    } else if (this.user.userPass !== this.user.confirmPass) {
                        callback(new Error('两次密码输入不一致!'));
                    } else {
                        callback();
                    }
                    callback();
                }
                callback();
            }
        };
        var mobilePhoneNumber = (rule, value, callback) => { 
            
            if (!value) {
                callback(new Error('请输入手机号码'));
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        };
		// var operateValidator = (rule, value, callback) => {
		//     if (this.userState == 'add') {
		//         if (this.user.operatePass === null) {
		//             callback(new Error('操作密码不能为空!'));
		//         } else if (this.user.confirmOperate === null) {
		//             callback(new Error('确认密码不能为空!'));
		//         } else if (this.user.operatePass !== this.user.confirmOperate) {
		//             callback(new Error('两次密码输入不一致!'));
		//         } else {
		//             callback();
		//         }
		//     } else if (this.userState == 'edit') {
		//         if (this.user.operatePass !== null) {
		//             if (this.user.confirmOperate === null) {
		//                 callback(new Error('确认密码不能为空!'));
		//             } else if (this.user.operatePass !== this.user.confirmOperate) {
		//                 callback(new Error('两次密码输入不一致!'));
		//             } else {
		//                 callback();
		//             }
		//             callback();
		//         }
		//         callback();
		//     }
		// };
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            PROMOTER_code: PROMOTER,
            PROMOTER_search: PROMOTER_SEARCH,
            form: {
                userName: '',
                userId: ''
            },
            dialogVisible: false,
            changeVisible: false,
            removeLimitVisible: false,
            isImportDate: false,
            loading: false,
            showDialog: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 10,
            currentUserId: '',
            userTablePopupId:' ',
            userState: 'add',
            treeProps: {
                children: 'children',
                label: 'deptName'
            },
            userStates: {
                add: '添加用户',
                check: '查看用户',
                edit: '编辑用户'
            },
            multipleSelection: [],
            userList: [],
            isSearch: false,
            user: {
                id: '',
                userName: '', //用户名
                userPass: null, //密码
                confirmPass: null,
                userRealname: '', //真实姓名
                userIdnumber: '', //身份证号
                authStatus: 0, //是否实名
                userMobile: '', //手机号码
                userTelephone: '', //用户电话
                userEmail: '', //邮箱
                companyId: '', //公司
                deptId: '', //部门
                workNumber: '', //工号
                postIds: '', //岗位
                gradeId: '61cdc5f5fbca4363b88d3f6f6f493816', //等级
                mppDept: {},
                mppGrade: {},
                userHeader: '',
                company: {},
                roleIds: [],
                postIdList: [],
                roleId: '',
                status: 1,
                isLimit: 0,
                limitReason: '', //限制备注
                removeLimitTime:null, //限制结束时间
                forbidTransfer: 0,
                personalPerformance: '', //个人业绩
                teamPerformance: '', //团队业绩
                directNumber: '', //直推人数
                teamNumber: '', //团队人数
                isAuthGrade: 0,
                authGradeId: '',
                userNickname: '',
				isMember:0,
				weight:'1',
                parentId:"",
                isSa: 0,
                shopNum: 0,
            },
            btnLoading: false,
            rules: {
                userName: [{ required: true, message: '登录名不能为空', trigger: 'blur' }],
                userPass: [{ required:true, validator: passwordValidator, trigger: 'blur' }],
                confirmPass: [{ required:true,validator: passwordValidator, trigger: 'blur' }],
				// operatePass: [{ validator: operateValidator, trigger: 'blur' }],
				// confirmOperate: [{ validator: operateValidator, trigger: 'blur' }],
                userRealname: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
                userMobile: [{ required: true, validator:mobilePhoneNumber, trigger: 'blur' }],
                userNickname: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
                companyId: [{ required: true, message: '公司不能为空', trigger: 'blur' }],
                deptId: [{ required: true, message: '部门不能为空', trigger: 'blur' }],
				workNumber: [{ required: true, message: '工号不能为空', trigger: 'blur' }],
                // removeLimitTime: [{ require: true, message: '限制结束时间不能为空', trigger: 'blur' }],
                //limitReason: [{ require: true, message: '限制备注不能为空', trigger: 'blur' }],
                // isHand: [{ required: true, message: '授权不能为空', trigger: 'blur' }],
                // handGrade: [{ required: true, message: '不能为空', trigger: 'blur' }]
            },
            auditStatus: [],
            currentId: '',
            changeId: '',
            srcList:[''],//大图预览，
            urgentStatusEnum:[],
            time: null,
            isDateTime: null,
            currentMobile: '',
            currentSmsCode: '',
            updateReason: '',
            updateImg:'',
            noChangeId:"",
            changeListVisible: false,
            changeList: [],
            imgList: [],
            uploadLoading:false,
            removeLimitForm: {
                phone: '',
                limitPicture: ''
            },
            limitUploadLoading: false,
            changeKValueVisible: false,
            changeKValueForm: {
                isChange: '',
                kValue: ''
            },
            currentKValueRow: null
        };
    },
    created() {
        this.getUserList();
        this.getAuditStatus();
        this.geturgentStatusEnum()
    },
    methods: {
        // 凭证释放记录导出
        releaseRecordFn(row){
            exprotExcel('/shop/incomevoucher/userIncomeExport',{userId:row.id}).then(res=>{
                if(res.success){
                    console.log({ res });
                }else{
                    console.log({ res });
                }
            });
        },
        // 恢复粉丝
        restoreFans(row){
            this.$confirm('此操作将恢复粉丝, 是否继续?', '修复', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => { 
                get('/manage/user/updateParentId',{userPhone:row.userMobile}).then(res=>{ 
                       if(res.code == 200){
                             this.$message({
                                message: res.message,
                                type: 'success',
                                duration: 2000
                            });
                       }else{
                          this.$message({
                                message: res.message,
                                type: 'error',
                                duration: 2000
                            })
                       }
                })

            });
        },
        // 解绑微信
        unbindWechat(row){
             this.$confirm('此操作将解绑微信, 是否继续?', '修复', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => { 
                get('/manage/user/unbindByPhone',{userMobile:row.userMobile}).then(res=>{ 
                      if(res.code == 200){
                          this.$message({
                            message: res.message,
                            type: 'success',
                            duration: 2000
                        })
                      }else{
                        this.$message({
                            message: res.message,
                            type: 'error',
                            duration: 2000
                        })
    
                      }
                })
            })
        },
        // 变更记录弹框展示
        changeListFn(item){
            get('/tianyilife/user/queryInviteLogList',{
                userId: item.id,
                pageNum: 1,
                pageSize: 100
            }).then((res)=>{
                if(res.success){
                    this.changeList = res.page.list;
                    this.imgList = res.page.list.map(item=>{
                        return item.pictureUrl;
                    });
                    this.changeListVisible = true;
                }else{
                    this.$message.closeAll();
                    this.$message.error(res.msg);
                }
            })
        },
        geturgentStatusEnum(){
            get('/mpp/utils/getEnum', {enumType:'yes_no'}).then((res)=>{
                this.urgentStatusEnum = res.enumList;
            });
        },
        sendSms(){
            if(this.time == null && this.isDateTime == null){
                get('mpp/utils/sendSmsCode', {mobile: this.currentMobile}).then((res)=>{
                    if(res.success){
                        this.time = 60;
                        this.isDateTime = setInterval(()=>{
                            this.time--;
                            if(this.time <= 0){
                                this.time = null;
                                clearInterval(this.isDateTime);
                                this.isDateTime = null;
                            }
                        },1000);
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });
            }
        },
        setLoginPassword(){
            get('/mpp/user/setDefaultUserPass').then((res)=>{
                if(res.success){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            })
        },
        setPatPassword(){
            get('/mpp/user/setDefaultOperatePass').then((res)=>{
                if(res.success){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            })
        },
        // 选择推广人
        getValuebrandId(value) {
        this.user.parentId = value;
        },
        search() {
            this.isSearch = !this.isSearch;
            this.$emit('send', this.isSearch);
        },
        getUserAuditStatus(auditStatus) {
            for (const index in this.auditStatus) {
                if (this.auditStatus[index].key == auditStatus) {
                    return this.auditStatus[index].value;
                }
            }
        },
        getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            uploadAvatar(formData).then((res) => {
                console.log({ res });
                if (res.success) {
                    this.user.userHeader = res.url;
                }
            });
        },
        resetUserList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.userList = [];
        },
        resetDialog() {
            this.$refs.userForm.resetFields();
            this.userState = 'add';
            this.showDialog = false;
            this.user = {
                userName: '', //用户名
                userPass: null, //密码
                confirmPass: null,
				operatePass:null,//密码
				confirmOperate:null,
                userRealname: '', //真实姓名
                userIdnumber: '', //身份证号
                authStatus: 0, //是否实名
                userMobile: '', //手机号码
                userTelephone: '', //用户电话
                userEmail: '', //邮箱
                companyId: '', //公司
                deptId: '', //部门
                workNumber: '', //工号
                postIds: '', //岗位
                gradeId: '61cdc5f5fbca4363b88d3f6f6f493816', //等级
                userHeader: '',
                mppDept: {},
                company: {},
                roleIds: [],
                postIdList: [],
                status: 1,
                isLimit: 0,
                limitReason: '', //限制备注
                removeLimitTime: null, //限制结束时间
                forbidTransfer: 0,
                personalPerformance: '', //个人业绩
                teamPerformance: '', //团队业绩
                directNumber: '', //直推人数
                teamNumber: '', //团队人数
                isAuthGrade: '',
                authGradeId: '',
                userNickname: '',
				isMember:0,
				weight:'1',
                parentId:"",
                isSa: 0,
                shopNum: 0,
            };
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.userState == 'add') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        const user = {
                            ...this.user,
                            postIds: this.user.postIdList.join(',')
                        };
                        addUserInsert({ ...user }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetUserList();
                                this.resetDialog();
                                this.getUserList(this.queryForm);
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.userState == 'edit') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        const user = {
                            ...this.user,
                            postIds: this.user.postIdList.join(',')
                        };
                        delete user.company;
                        delete user.mppDept;
                        delete user.postList;
                        delete user.mppRoleList;
                        delete user.postIdList;
                        delete user.mppGrade;
						delete user.currencyMoneyList;
						delete user.nodeLinearList;
						delete user.growth;
                        updateById({ ...user }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetUserList();
                                this.resetDialog();
                                this.getUserList(this.queryForm);
                            }else{
								this.$message({
								    message: res.msg,
								    type: 'error',
								    duration: 2000
								});
							}
                        });
                    }
                });
            }
        },
        addUserInsert() {
            this.showDialog = true;
            this.userState = 'add';
        },
        // 查看
        checkUser(userId) {
            this.currentUserId = userId;
            this.getUserDetail();
            this.showDialog = true;
            this.userState = 'check';
        },
        // 编辑
        editUser(userId) {
            if (userId) {
                this.currentUserId = userId;
                this.getUserDetail();
            } else {
                this.user = { ...this.user, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.userState = 'edit';
        },
        // 打开
        editUserRouter(row){
            this.userTablePopupId = row;
           this.dialogVisible = true;
        },
        // 删除
        deleteUser(userId) {
            let ids = '';
            if (userId) {
                ids = userId;
            } else {
                ids = this.multipleSelection.map((user) => user.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteUser({ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: '删除用户成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.resetUserList();
                            this.getUserList(this.queryForm);
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        /**
         * 导出出岗位信息
         */
        exportPostList() {
            this.btnLoading = true;
            exprotExcel(`/mpp/user/export`, this.post, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/user/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate ? true : false;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            importDate(`/mpp/user/importData`, formData);
            this.refreshPostList();
        },
        refreshUserList() {
            this.resetUserList();
            this.getUserList();
        },
        getUserList(query = {}) {
            this.loading = true;
            getUserList({ ...query, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.userList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },

        getUserDetail() {
            getUserDetail({ id: this.currentUserId }).then((res) => {
                if (res.success) {
                    this.user = {
                        ...this.user,
                        ...res.mppUser,
                        postIdList: res.mppUser.postIds ? res.mppUser.postIds.split(',') : [],
                        gradeId: res.mppUser.mppGrade.id
                    };
                    if (this.user.forbidTransfer == null) {
                        this.user.forbidTransfer = 0;
                    }
                }
            });
        },
        // 选中
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getUserList(this.queryForm);
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getUserList(this.queryForm);
        },
        repairPush(walletAddress) {
            get('/mpp/mq/userRepairPush', { walletAddress: walletAddress }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                }
            });
        },
        // 登录
        login(userName, userPass) {
            // let router = this.$router.resolve({
            //     path: 'http://192.168.0.105:8081/',
            //     query: {
            //         userName: userName,
            //         userPass: userPass
            //     }
            // });
            // window.open(router.href, '_blank');
            // console.log(userName, userPass);
            // window.open('http://192.168.0.102:8080/#/pages/assets/goAssets?userName=' + userName + '&userPass=' + userPass, '_blank');
            window.open('http://192.168.0.102:8080/#/pages/assets/goAssets?userName=' + userName, '_blank');
        },
        //链上
        chainButton(walletAddress) {
            window.open('https://bscscan.com/address/' + walletAddress, '_blank');
        },
         // 上传图片(变更关系)
        uploadPic(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            this.uploadLoading = true;
            upload(`/mpp/image/upload`, formData).then((res) => {
                if(res.success){
                    this.updateImg = res.url
                }else{
                    this.$message.error(res.msg);
                }
                this.uploadLoading = false;
            });
        },
        // 打开解除限制弹框
        openRemoveLimitDialog() {
            this.removeLimitVisible = true;
            this.removeLimitForm = {
                phone: '',
                limitPicture: ''
            };
        },
        // 关闭解除限制弹框
        closeRemoveLimitDialog() {
            this.removeLimitVisible = false;
            this.removeLimitForm = {
                phone: '',
                limitPicture: ''
            };
            if (this.$refs.removeLimitForm) {
                this.$refs.removeLimitForm.resetFields();
            }
        },
        // 上传限制图片
        uploadLimitPicture(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
                return;
            }
            const formData = new FormData();
            formData.append('file', file);
            this.limitUploadLoading = true;
            upload(`/mpp/image/upload`, formData).then((res) => {
                if(res.success){
                    this.removeLimitForm.limitPicture = res.url;
                }else{
                    this.$message.error(res.msg);
                }
                this.limitUploadLoading = false;
            }).catch((err) => {
                this.$message.error('图片上传失败');
                this.limitUploadLoading = false;
            });
        },
        // 提交解除限制
        submitRemoveLimit() {
            this.$refs.removeLimitForm.validate((valid) => {
                if (valid) {
                    if (!this.removeLimitForm.phone) {
                        this.$message({
                            message: '请输入手机号',
                            type: 'warning',
                            duration: 2000
                        });
                        return;
                    }
                    if (!this.removeLimitForm.limitPicture) {
                        this.$message({
                            message: '请上传图片',
                            type: 'warning',
                            duration: 2000
                        });
                        return;
                    }
                    postJson('/manage/limitOperate/updateUser', {
                        phone: this.removeLimitForm.phone,
                        limitPicture: this.removeLimitForm.limitPicture
                    }).then((res) => {
                        if (res.success || res.code == 200) {
                            this.$message({
                                message: res.msg || '解除限制成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.closeRemoveLimitDialog();
                        } else {
                            this.$message({
                                message: res.message || '解除限制失败',
                                type: 'error',
                                duration: 2000
                            });
                        }
                    }).catch((err) => {
                        this.$message({
                            message: err.response?.data?.msg || '解除限制失败',
                            type: 'error',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        // 变更k值
        changeKValue(row) {
            this.currentKValueRow = row;
            this.changeKValueVisible = true;
            this.changeKValueForm = {
                isChange: '',
                kValue: ''
            };
        },
        // 关闭变更k值弹框
        closeChangeKValueDialog() {
            this.changeKValueVisible = false;
            this.changeKValueForm = {
                isChange: '',
                kValue: ''
            };
            this.currentKValueRow = null;
            if (this.$refs.changeKValueForm) {
                this.$refs.changeKValueForm.resetFields();
            }
        },
        // k值输入处理，只允许数字（包含小数）
        handleKValueInput(value) {
            // 只保留数字和小数点，确保只有一个小数点
            let newValue = value.replace(/[^\d.]/g, '');
            // 确保只有一个小数点
            const parts = newValue.split('.');
            if (parts.length > 2) {
                newValue = parts[0] + '.' + parts.slice(1).join('');
            }
            // 如果以小数点开头，在前面加0
            if (newValue.startsWith('.')) {
                newValue = '0' + newValue;
            }
            this.changeKValueForm.kValue = newValue;
        },
        // 提交变更k值
        submitChangeKValue() {
            if (this.changeKValueForm.isChange === '') {
                this.$message({
                    message: '请选择是否参与计算',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            if (!this.changeKValueForm.kValue || this.changeKValueForm.kValue === '') {
                this.$message({
                    message: '请输入k值',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }else{
                const kValue = parseFloat(this.changeKValueForm.kValue);
                if (isNaN(kValue)) {
                    this.$message({
                        message: 'k值必须是数字',
                        type: 'warning',
                        duration: 2000
                    });
                    return;
                }
                if (kValue < 0.01 || kValue > 1) {
                    this.$message({
                        message: 'k值必须是大于等于0.01且小于等于1的数字',
                        type: 'warning',
                        duration: 2000
                    });
                    return;
                }
            }
            get('/user/changeK', {
                id: this.currentKValueRow.id,
                flag: this.changeKValueForm.isChange,
                k: Number(this.changeKValueForm.kValue)
            }).then((res) => {
                if (res.success || res.code == 200) {
                    this.$message({
                        message: res.msg || '变更成功',
                        type: 'success',
                        duration: 2000
                    });
                    this.closeChangeKValueDialog();
                    this.getUserList(this.queryForm);
                } else {
                    this.$message({
                        message: res.msg || '变更失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            }).catch((err) => {
                this.$message({
                    message: err.response?.data?.msg || '变更失败',
                    type: 'error',
                    duration: 2000
                });
            });
        },
        // 变更关系
        handleClose(done) {
            this.changeVisible = false;
            this.updateReason = ''
            this.updateImg = ''
        },
        ChangeRelationship(item) {
            this.changeVisible = true;
            this.noChangeId = item.id;
            eventBus.$emit('empty', '');
        },
        finish() {
            if (this.changeId == '') {
                this.$message({
                    message: '请选择用户',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            if (this.updateReason == '') {
                this.$message({
                    message: '请添加修改原因',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            if (this.updateImg == '') {
                this.$message({
                    message: '请上传纸质申请单',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            
            post('/tianyilife/user/changeParentId', { userId: this.noChangeId, inviteUserId: this.changeId, pictureUrl: this.updateImg, changeReason: this.updateReason }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
                this.updateReason = ''
                this.updateImg = ''
                this.changeVisible = false;
            });
        },
        getValue(value) {
            this.changeId = value;
        },

        //修复
        auditRepair(id) {
            this.$confirm('此操作将修复关系, 是否继续?', '修复', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    get(`/mpp/user/repairPath`, { userId: id }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            // this.findNotParentList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        repairDirect(id) {
            this.$confirm('此操作将修复有效直推, 是否继续?', '修复', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    get(`/mpp/user/repairDirect`, { userId: id }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            // this.findNotParentList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        repairTeam(id) {
            this.$confirm('此操作将修复有效团队, 是否继续?', '修复', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    get(`/mpp/user/repairTeam`, { userId: id }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            // this.findNotParentList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        audit(id) {
            get(`/mpp/user/auditPath`, { userId: id }).then((res) => {
                if (res.success && res.code == 200) {
                    if (res.newPath == res.parentPath) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        updateSrcList(src){
            this.srcList[0] = src
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.content {
    flex: 1;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.theme-color{
    & > span{
        margin-left: 3px;
    }
    color: #409eff;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

::v-deep .el-dropdown{
    font-size: 12px;
    color: #409eff;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.nameImg {
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Safari and Chrome */
    transform: rotate(90deg);
}

/* 确保表格容器可以滚动 */
.page-content {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.page-content .flex-1 {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 确保表格可以滚动 */
::v-deep .page-content .el-table__body-wrapper {
    overflow-y: auto !important;
    overflow-x: auto !important;
}
</style>
